import {
  Avatar,
  Box,
  CardMedia,
  Grid,
  IconButton,
  LinearProgress,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Tweet } from "react-twitter-widgets";
import "./TwitterContentData.scss";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

function TwitterContentData({ content, title, titleIcon }) {
  const scrollContainer = useRef();
  const mobileBreakPoint = useMediaQuery("(max-width:430px)");
  return (
    <Box className="container contentMainContainer">
      <Box className="mainHeading">
        {" "}
        <img style={{ marginRight: "12px" }} src={titleIcon} />
        {title}
      </Box>
      <hr
        style={{
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "rgba(0, 0, 0, 0.12)",
        }}
      />
      <Box
        sx={
          mobileBreakPoint
            ? {
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
              }
            : {
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
                marginLeft: "-45px",
                marginRight: "-45px",
              }
        }
        className="content-scroll-container"
        ref={scrollContainer}
      >
        <IconButton
          aria-label="left-scroll"
          className="left-scroll-btn"
          onClick={() => {
            scrollContainer.current.scrollBy(-400, 0);
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          aria-label="left-scroll"
          className="right-scroll-btn"
          onClick={() => {
            scrollContainer.current.scrollBy(400, 0);
          }}
        >
          <ChevronRightIcon />
        </IconButton>
        {content.data.map((content, index) => (
          <>
            <Box className="contentContiner">
              <Tweet
                tweetId={content.url.split("/")[5]}
                options={{ width: "454" }}
              />
            </Box>
          </>
        ))}
        <Box className="linearGradientRight"></Box>
        <Box className="linearGradientLeft"></Box>
      </Box>
    </Box>
  );
}

export default TwitterContentData;
